import axios from 'app/axiosInstance'

export const getAuthenticatedUser = () => {
    return axios().get('v1/users/_info')
}

export const logoutUser = () => {
    return axios().get('oauth/logout')
}

export const refreshToken = () => {
    return axios().post('oauth/refreshtoken')
}
